import { Button } from "@admin/components/atoms/Button";
import { Label } from "@admin/components/atoms/Input/Label";
import { useCurrentUserGroups } from "@admin/hooks/useCurrentUserGroups";
import { SushiRicePhControlModal } from "@admin/pages/food-management/control-points/components/Modals/SushiRicePhControlModal";
import {
  buttonColorMap,
  FoodControlPointInstance,
  InstanceStatusColorAndMeanings,
  isWithinLast24Hours,
  StatusBgColors,
  SushiRice,
} from "@enos-monorepo/lib";
import { sushiRicePhOptions } from "@enos-monorepo/lib";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { CorrectiveActions } from "../CorrectiveActions";
import { DeleteInstanceModal } from "../DeleteInstanceModal";
interface SushiRicePhControlTextsProps {
  datas: {
    controlData: SushiRice;
    instance: FoodControlPointInstance;
    isNewArchitecture?: boolean;
  }[];
  callBack?: () => void;
}

export function SushiRicePhControlTexts({
  datas,
  callBack,
}: SushiRicePhControlTextsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInstance, setSelectedInstance] =
    useState<FoodControlPointInstance>();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const { t } = useTranslation();

  const { isSuperAdmin } = useCurrentUserGroups();

  const onEdit = (instance: FoodControlPointInstance) => {
    setSelectedInstance(instance);
    setIsModalOpen(true);
  };

  const onDelete = useCallback((instance: FoodControlPointInstance) => {
    setSelectedInstance(instance);
    setIsDeleteOpen(true);
  }, []);

  return (
    <div className="flex flex-col gap-5">
      {datas?.map((data, index) => {
        const status = InstanceStatusColorAndMeanings(t).find(
          (i) => i.type === data.instance.status,
        );
        const bgColorClass =
          StatusBgColors[
            data?.controlData?.status as keyof typeof StatusBgColors
          ];

        const buttonColor = buttonColorMap[data?.controlData?.status];

        return (
          <div
            className={`${bgColorClass} rounded-xl`}
            key={data.controlData.controlPointInstanceId ?? "" + index}
          >
            {(isSuperAdmin ||
              isWithinLast24Hours(data.instance.updatedDate)) && (
              <div className="flex flex-row justify-end">
                <Button
                  size="sm"
                  property={buttonColor}
                  onClick={() => onEdit(data.instance)}
                >
                  Edit
                </Button>
              </div>
            )}
            <div
              className="px-5 py-8"
              key={(data.controlData.controlPointInstanceId ?? "") + index}
            >
              <Label title={t("common.Status")}>
                <span style={{ color: status?.color }}> {status?.name} </span>
              </Label>
              <Label title={t("food.pH Measurement")}>
                {
                  sushiRicePhOptions(t).find(
                    (item) => item.value === data.controlData.selectedPhId,
                  )?.label
                }
              </Label>
              {data.instance.remark && (
                <Label title={t("food.Remarks")}>{data.instance.remark}</Label>
              )}
              {data.instance.reason && (
                <Label title={t("food.Corrective Action")}>
                  <CorrectiveActions correctiveActions={data.instance.reason} />
                </Label>
              )}
              <div
                className={`w-2 h-2 ${
                  data.isNewArchitecture ? "bg-green-500" : "bg-red-500"
                } rounded-full inline-block`}
              ></div>
            </div>
            {isSuperAdmin && (
              <div className="flex flex-row justify-end">
                <Button
                  size="sm"
                  property="danger"
                  onClick={() => onDelete(data.instance)}
                >
                  {t("common.Delete")}
                </Button>
              </div>
            )}
          </div>
        );
      })}
      {selectedInstance && (
        <>
          <SushiRicePhControlModal
            foodControlPointInstance={selectedInstance}
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            initialData={JSON.parse(selectedInstance.data || "{}")}
          />
          <DeleteInstanceModal
            open={isDeleteOpen}
            onClose={() => setIsDeleteOpen(false)}
            selectedInstance={selectedInstance}
            callBack={callBack}
          />
        </>
      )}
    </div>
  );
}
